














import Vue from 'vue'

export default Vue.extend({
  name: 'copy-mech-dialog',
  props: {
    mech: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    show() {
      this.dialog = true
    },
    hide() {
      this.dialog = false
    },
    dupe() {
      this.$emit('copy')
      this.hide()
    },
  },
})
